import React from 'react';
import clsx from 'clsx';
import { Table } from 'semantic-ui-react';
import RowDeleteButton from '@/components/buttons/RowDeleteButton';
import CollectionLabel from '@/collections/components/CollectionLabel';

const DatasetCollectionAssignRow = ({
  collection,
  className,
  removeCollection,
}) => (
  <Table.Row className={clsx('aridhia-dataset-collection-assign-row', className)}>
    <Table.Cell>
      <CollectionLabel collection={collection} asLink={false} />
    </Table.Cell>
    <Table.Cell collapsing>
      <RowDeleteButton entity="collection.dataset" floated="right" onClick={() => removeCollection(collection.code)} />
    </Table.Cell>
  </Table.Row>
);

export default DatasetCollectionAssignRow;
